import _ from 'lodash';

/**
 * @param dictionary {object}
 * @param componentType {string}
 * @param property {string}
 * @returns {string}
 */
export function getText(dictionary, componentType, property) {
	return _.get(dictionary, `${componentType}.${property}`, 'None');
}
